import { isSubscriptionOnHold, type SubscriptionLike } from "@/lib/billing/entitlements";
import { DIAMOND_MONTHLY_PRICE_ID } from "@/lib/billing/tier-price-ids";

export type DiamondPass = { readonly ends_at: string };

type LiveRow = SubscriptionLike & { period_end?: string | null };

const PAYING_STATUSES = new Set(["active", "trialing"]);

const DIAMOND_PASS_ROW = {
  price_id: DIAMOND_MONTHLY_PRICE_ID,
  status: "active",
  held_until: null,
  hold_started_at: null,
} as const;

function isPayingRow(row: LiveRow, nowMs: number, now: Date): boolean {
  if (!PAYING_STATUSES.has(row.status ?? "")) return false;
  if (row.period_end && Date.parse(row.period_end) <= nowMs) return false;
  return !isSubscriptionOnHold(row, now);
}

export function withDiamondPass<Row extends LiveRow>(
  rows: readonly Row[],
  passes: readonly DiamondPass[] | null | undefined,
  now: Date = new Date(),
): Array<Row | typeof DIAMOND_PASS_ROW> {
  const nowMs = now.getTime();
  const passLive = (passes ?? []).some((pass) => Date.parse(pass.ends_at) > nowMs);
  if (!passLive || !rows.some((row) => isPayingRow(row, nowMs, now))) return [...rows];
  return [...rows, DIAMOND_PASS_ROW];
}
